import { render, staticRenderFns } from "./Adjust.template.vue?vue&type=template&id=4a0a533e&scoped=true&"
var script = {}
import style0 from "./Adjust.template.vue?vue&type=style&index=0&id=4a0a533e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0a533e",
  null
  
)

export default component.exports